import {
  Frequency,
  StandardDeliveryDeviceHigherCategoryReport,
  StandardDeliveryReport,
} from '../../../../apis/graphql/types';
import { reportInitialValues } from './ReportForm/constants';
import { ReportFormValues } from './ReportForm/types';

export const getInitialValuesForReportForm = (
  report?: StandardDeliveryReport | StandardDeliveryDeviceHigherCategoryReport
): ReportFormValues => {
  return report
    ? {
        name: report.name,
        format: report.exportFormat,
        emailNow: report.schedule.emailNow || false,
        scheduleReport: !!report.schedule.frequency,
        frequency: report.schedule.frequency || Frequency.Weekly,
        days: report.schedule.days || [],
        recipients: report.recipients || [],
      }
    : reportInitialValues;
};

export const capitalizeFirstLetter = (str: string): string => {
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};
